
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IItemLocation } from "@tylertech/tyler-api-types";

/**
 * ItemLocationService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ItemLocationService {
    constructor(private readonly $apiService: ApiService) { }
    
    DeleteItemLocation(pItemLocationId: string): Promise<boolean> {
        return this.$apiService.sendAuth("IItemLocationService/DeleteItemLocation", pItemLocationId);
    }
    GetItemLocationCounts(entity: IItemLocation): Promise<IItemLocation> {
        return this.$apiService.sendAuth("IItemLocationService/GetItemLocationCounts", entity);
    }
    GetItemLocations(pItemId: string): Promise<IItemLocation[]> {
        return this.$apiService.sendAuth("IItemLocationService/GetItemLocations", pItemId);
    }
    SaveItemLocation(pItemLocation: IItemLocation): Promise<IItemLocation> {
        return this.$apiService.sendAuth("IItemLocationService/SaveItemLocation", pItemLocation);
    }
}
